import(/* webpackMode: "eager" */ "/vercel/path0/web/src/app/(site)/(home)/page.tsx");
